@use '~/theme/theme' as *;

.popover {
  width: 320px;
  padding: spacing(2);
}

.trendingUp,
.trendingDown {
  position: absolute;
  margin-right: spacing(1);
}

.trendingUp {
  color: color(green-800);
}

.trendingDown {
  color: color(lobster-800);
}
